/* eslint-disable i18next/no-literal-string */
import { Button, TypographyStylesProvider } from '@mantine/core';
import type { ContextModalProps } from '@mantine/modals';
import { useTranslation } from 'react-i18next';

export const HowToPlayModal = ({ context, id }: ContextModalProps) => {
  const { t } = useTranslation();

  return (
    <>
      <TypographyStylesProvider data-test-id="how-to-play-content" mb={16}>
        <ul>
          <li>
            Select your difficulty level - Higher difficulty means higher
            rewards.
          </li>
          <li>Start your climb - Move up the temple, step by step.</li>
          <li>
            Cash out before hitting spoiled cheese - If you do, you win the
            prize!
          </li>
        </ul>
        <p>Take the risk, time your exit, and claim your winnings!</p>
        <hr />
        <h2>Game Details</h2>
        <h3>Placing a Bet</h3>
        <ol>
          <li>
            Enter your desired amount in the <strong>"Amount"</strong> field.
          </li>
          <li>
            Choose your difficulty level (the harder it gets, the higher the
            reward!):
            <ul>
              <li>
                <strong>Easy</strong> - 3 out of 4 blocks are safe
              </li>
              <li>
                <strong>Medium</strong> - 2 out of 3 blocks are safe
              </li>
              <li>
                <strong>Hard</strong> - 1 out of 2 blocks is safe
              </li>
              <li>
                <strong>Extreme</strong> - 1 out of 3 blocks is safe
              </li>
              <li>
                <strong>Nightmare</strong> - 1 out of 4 blocks is safe
              </li>
            </ul>
          </li>
        </ol>
        <p>
          Click <strong>"Start"</strong> to begin your climb.
        </p>
        <hr />
        <h2>How It Works</h2>
        <p>
          Tap to open blocks and avoid the spoiled cheese. Your goal is to find
          the coin in each row to move up.
        </p>
        <ul>
          <li>Every level you pass increases your potential winnings.</li>
          <li>
            But if you hit spoiled cheese, you lose your bet — so pick wisely!
          </li>
        </ul>
        <hr />
        <h2>Cashing Out</h2>
        <ul>
          <li>
            Once you've passed at least one level, you can hit{' '}
            <strong>"Cash Out"</strong> to secure your prize.
          </li>
          <li>
            Complete all levels? The game will automatically cash you out with
            the full reward.
          </li>
        </ul>
        <hr />
        <h2>RTP (Return to Player)</h2>
        <p>This game uses a statistical model called RTP - Return to Player.</p>
        <ul>
          <li>
            <strong>RTP:</strong> 95.0%
          </li>
          <li>
            This means that over billions of rounds, 95% of total bets are
            expected to be paid out in winnings.
          </li>
        </ul>
      </TypographyStylesProvider>

      <Button
        data-test-id="how-to-play-close-button"
        fullWidth
        mb={16}
        onClick={() => context.closeModal(id)}
      >
        {t('howToPlayModal.closeButton')}
      </Button>
    </>
  );
};
